import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const CounterTimeCircleCustom = (props) => {
  const [isComplete, setIsComplete] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (props.resetKey) {
      setKey(props.resetKey);
      setIsComplete(false);
    }
  }, [props.resetKey]);

  return (
    <div className="d-flex align-items-center">
      <CountdownCircleTimer
        key={key}
        isPlaying
        duration={props.durationSeconds}
        size={40} // Ajusta el tamaño aquí
        strokeWidth={4} // Ajusta el grosor del círculo aquí
        colors={["#4A90E2", "#E94E77", "#F0A202"]}
        colorsTime={[props.durationSeconds, props.durationSeconds / 2, 0]}
        onComplete={() => {
          setIsComplete(true);
          props.onExecuteAction();
          return { shouldRepeat: false };
        }}
      >
        {({ remainingTime }) => <span className="text-xs font-bold">{remainingTime}s</span>}
      </CountdownCircleTimer>
      <span className="text-sm ml-2">{isComplete ? props.executingText : props.remainingText}</span>
    </div>
  );
};

CounterTimeCircleCustom.propTypes = {
  durationSeconds: PropTypes.number,
  remainingText: PropTypes.string,
  executingText: PropTypes.string,
  resetKey: PropTypes.number,
  onExecuteAction: PropTypes.func,
};

export default CounterTimeCircleCustom;
